// Aufbereitung der Spieleraktivitaet fuer die Anzeige (Issue #1746). Reine Funktionen, damit sie ohne Rendering
// testbar sind.

// Wie useTime, aber als Funktion - fuer Tabellenzeilen, in denen kein Hook aufgerufen werden darf.
export function formatDuration(seconds, qualifiers = 2) {
    if (!seconds) {
        return "0 Minuten"
    }
    const units = [[86400, "Tag", "Tage"], [3600, "Stunde", "Stunden"], [60, "Minute", "Minuten"],
        [1, "Sekunde", "Sekunden"]]
    let rest = Math.floor(seconds)
    const parts = []
    for (const [size, singular, plural] of units) {
        const amount = Math.floor(rest / size)
        rest -= amount * size
        if (amount > 0 && parts.length < qualifiers) {
            parts.push(amount + " " + (amount === 1 ? singular : plural))
        }
    }
    return parts.join(" ")
}

export function formatDate(millis) {
    return new Date(millis).toLocaleDateString("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" })
}

function average(amount, players) {
    if (amount === undefined) {
        return undefined
    }
    return players > 0 ? Math.round((amount / players) * 10) / 10 : 0
}

// Die Zeilen des Wochenvergleichs: je Kennzahl der Wert der letzten und der laufenden Woche.
// weekStats: { "<week>": { activities, quests } } aus /api/stats, fehlt solange noch geladen wird.
export function weekComparisonRows(weeks, weekStats, settings) {
    const value = (week, key) => week[key]
    const stat = (week, key) => (weekStats[week.week] || {})[key]
    const minutes = Math.round(settings.never_active_seconds / 60)
    const hours = Math.round((settings.regular_seconds / 3600) * 10) / 10
    const rows = [
        ["Neue Spieler", week => value(week, "new_players")],
        ["davon regulär geworden (ab " + hours + " h)", week => value(week, "new_became_regular")],
        ["davon unter " + minutes + " Minuten gespielt", week => value(week, "new_never_active")],
        ["Inaktiv geworden", week => value(week, "became_inactive")],
        ["Aktive Spieler", week => value(week, "active_players")],
        ["Spieler mit Sitzung", week => value(week, "total_players")],
        ["Erledigte Aktivitäten", week => stat(week, "activities")],
        ["Ø Aktivitäten je Spieler", week => average(stat(week, "activities"), week.total_players)],
        ["Erledigte Quests", week => stat(week, "quests")],
        ["Ø Quests je Spieler", week => average(stat(week, "quests"), week.total_players)],
    ]
    return rows.map(([label, read]) => ({ label, values: weeks.map(read) }))
}

// Balkendiagramm der Erfahrung je Fertigkeit aus /api/points/<spieler>: alle Punktetypen "Erfahrung-*",
// absteigend sortiert. Liefert ausserdem den Ruf.
export function experienceAndReputation(pointsEntries) {
    let reputation
    const experience = []
    for (const entry of pointsEntries || []) {
        const points = (entry.stats || []).reduce((sum, stat) => sum + (Number(stat.points) || 0), 0)
        if (entry.name === "Ruf") {
            reputation = points
        } else if (typeof entry.name === "string" && entry.name.startsWith("Erfahrung-")) {
            experience.push({ skill: entry.name.substring("Erfahrung-".length), points })
        }
    }
    experience.sort((a, b) => b.points - a.points)
    return { reputation, experience }
}
